import React, { useState } from "react";
import { Field, ErrorMessage } from "formik";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
// import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import PriorityHighIcon from "@material-ui/icons/PriorityHigh";
import TextError from "./TextError";

// const styles = {
//   // root: {
//   //   background: "black",
//   // },
//   root1: {
//     display: "none",
//   },
//   root2: {
//     // color: "red",
//     display: "block",
//   },
//   input: {
//     startAdornment: (
//       <InputAdornment position="start">
//         <PriorityHighIcon style={{ color: "red" }} />
//       </InputAdornment>
//     ),
//   },
// };

const startAdornment = (isDisplay) => ({
  startAdornment: (
    <InputAdornment position="start">
      <PriorityHighIcon style={{ color: "red", display: isDisplay }} />
    </InputAdornment>
  ),
});

function Input(props) {
  const { classes } = props;
  const [isDisplay, setisDisplay] = useState("none");
  const {
    label,
    name,
    field,
    errorobj,
    touched,
    onChange,
    blur,
    ...rest
  } = props;
  // console.log("Input: ", props);
  const myBlur = () => {
    // console.log('Blur',errorobj);
  };

  return (
    // <div className="form-control">

    <div>
      {/* <label htmlFor={name}>{label}</label> */}
      <Field id={name} name={name} label={label} {...rest}>
        {({
          field, // { name, value, onChange, onBlur }
          form: { touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
          meta,
        }) => (
          // setisDisplay("none")
          <div>
            {/* {meta.touched && meta.error && (isDisplay = "block")} */}
            {/* <input type="text" placeholder="Name" {...field} /> */}

            {/* {meta.touched && meta.error && (
                <PriorityHighIcon style={{ color: "red", display: "block" }} />
              )} */}

            <TextField
              id={name}
              name={name}
              label={label}
              {...rest}
              {...field}
              // className={classes.root}

              // InputProps={{
              //   startAdornment: (
              //     <InputAdornment
              //       position="start"
              //       // style={{ display: "block" }}
              //       // className={classes.root1}
              //       // className={!meta.touched && !meta.error && (
              //       //     classes.root1
              //       //   )}
              //       // className={meta.touched && meta.error && (
              //       //   classes.root2
              //       // )}
              //     >
              //       <PriorityHighIcon
              //         style={{ color: "red" }}
              //         // style={{display:'none'}}
              //         // className={classes.root1}
              //         // className={
              //         //   meta.touched &&
              //         //   meta.error &&
              //         //   classes.root2 // Display:none
              //         // }
              //       />
              //     </InputAdornment>
              //   ),
              //   // className: classes.input,
              // }}

              // InputProps={{
              //   classes: {
              //     root: props.classes.style
              //   },
              // }}

              InputProps={
                // style('block')
                meta.touched && meta.error && startAdornment("block")
              }
            ></TextField>

            {meta.touched && meta.error && (
              <div className="error">{meta.error}</div>
            )}
          </div>
        )}
      </Field>
      {/* <TextField
        id={name}
        name={name}
        label={label}
        onChange={onChange}
        touched={touched}
        {...rest}
        {...field}
        onBlur={myBlur}
        // helperText={errorobj}
      ></TextField> */}
      {/* <ErrorMessage name={name} component={TextError}></ErrorMessage> */}
    </div>
  );
}

Input.propTypes = {
  classes: PropTypes.object.isRequired,
};

// export default withStyles(styles)(Input);
export default Input;
